import { sendFile } from './sendFile';

import { FileUploadParams, UploadProcess } from './types';

const CHUNK_SIZE = 5 * 1024 * 1024;

export abstract class FileService {
    public abstract getDownloadLink(
        path: string,
        isOpenInBrowser?: boolean,
        downloadFileName?: string,
    ): Promise<string>;

    public abstract makeSharedLink(path: string): Promise<string>;

    public abstract getSharedLink(path: string, downloadFileName?: string): Promise<string>;

    public async upload(file: File, params: FileUploadParams): Promise<void> {
        for await (const { progress } of this.uploadProcess(file, params)) {
            console.info(`Загружено ${progress}%`);
        }
    }

    public async *uploadProcess(file: File, params: FileUploadParams): AsyncIterableIterator<UploadProcess> {
        if (file.size <= CHUNK_SIZE) {
            await this.whollyUpload(file, params);
            return { progress: 100 };
        }

        const chunks = this.separateFileByChunks(file);
        for await (const value of this.multipartUploadProcess(chunks, params)) {
            yield value;
        }
    }

    protected abstract multipartUploadProcess(
        chunks: Blob[],
        settings: FileUploadParams,
    ): AsyncIterableIterator<UploadProcess>;

    protected abstract whollyUpload(file: File, settings: FileUploadParams): Promise<void>;

    protected separateFileByChunks(file: File): Blob[] {
        const chunks: Blob[] = [];

        let position = 0;
        let currentChunk: Blob;

        while (position < file.size) {
            currentChunk = file.slice(position, position + CHUNK_SIZE);
            chunks.push(currentChunk);
            position += CHUNK_SIZE;
        }

        return chunks;
    }

    protected async sendFile<Response = any>(url: string, file: File | Blob, data: object): Promise<Response> {
        return sendFile(url, file, data);
    }
}
